import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'
import request from './utils/request'
import * as api from './api'

Vue.use(ElementUI)
Vue.prototype.$request = request
Vue.prototype.$api = api

Vue.config.productionTip = false

// 应用启动时全局拉取一次系统配置（公司名称/电话/地址等）
store.dispatch('fetchSystemConfig')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
